/**
 * Checks if the object provided is of the generic type T. it does this by checking if the prop provided is in the given object
 * @param object the object of which we are checking
 * @param propInT the prop within the given type to be checking
 * @returns true if object is of type
 *
 * @example
 * // Check if obj is a map layer
 * if(instanceOf<MapLayer>(obj, "areaStyle"))
 * {
 *      // Do Something...
 * }
 */
export function instanceOf<T>(object, propInT: keyof T): object is T {
    try {
        return propInT in object;
    } catch {
        return false;
    }
}
